module.exports = __webpack_public_path__ + "img/aami2-31-512.eee3fd0d.png";